'use strict';

frontendApp.controller('ResetPasswordModalCtrl', ['$scope', '$http', '$uibModalInstance', 'ConfigService', function($scope, $http, $uibModalInstance, ConfigService) {

    $scope.saving = false;
    $scope.emailSent = false;

    $scope.close = function() {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };
    
    $scope.resetPassword = function(account) {
        $scope.saving = true;
        
		var data = _.pick(account, 'email');
        data.frontendUrl = ConfigService.getFrontendUrl();

		$http.post(ConfigService.getServerBaseUrl() + "/account/resetPassword", data).
			success(function(data, status) {
                $scope.saving = false;
                $scope.emailSent = true;
                
                // Here we're telling the user that he needs to check his email
                
			}).error(function(data, status) {
                $scope.saving = false;
				_.each(data.errors, function(error) {
					$scope.ResetPasswordForm[error.field].$setValidity(error.code, false);
				});
			});
        
    };
    
    
}]);
    
